import { Link as LinkIcon, Star, Trash2 } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

export const GmailAccounts = ({ configured, onConnect }) => {
  const [accounts, setAccounts] = useState([]);
  const load = useCallback(() => api.get("/gmail/accounts").then(({ data }) => setAccounts(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const act = async (fn, msg) => { try { await fn(); if (msg) toast.success(msg); load(); } catch { toast.error("Action impossible, réessayez."); } };
  const remove = (a) => window.confirm(`Retirer le compte ${a.email} ? Ses réponses déjà importées restent dans Réponses.`) && act(() => api.delete(`/gmail/accounts/${a.id}`), "Compte retiré.");

  return (
    <div className="gmail-accounts" data-testid="gmail-accounts">
      <p className="eyebrow">COMPTES GMAIL CONNECTÉS</p>
      {accounts.length === 0 && <p className="source-note" data-testid="gmail-no-account">{configured ? "Aucun compte connecté : ajoutez votre première boîte Gmail." : "Enregistrez d’abord les identifiants Google ci-dessus."}</p>}
      {accounts.map((a) => (
        <div key={a.id} className="gmail-account-row" data-testid={`gmail-account-${a.email}`}>
          <div className="gmail-account-main">
            <strong>{a.email}</strong>
            <div className="gmail-account-tags">
              {a.is_primary ? <span className="gmail-tag primary" data-testid={`gmail-primary-${a.email}`}>Principal · envois automatiques et devis</span> : <button type="button" className="link-button" onClick={() => act(() => api.post(`/gmail/accounts/${a.id}/primary`), `${a.email} est maintenant le compte principal.`)} data-testid={`gmail-make-primary-${a.email}`}><Star size={12} /> Définir comme principal</button>}
              {!a.modify && <span className="gmail-tag warn">Marquage « lu » inactif : reconnectez ce compte</span>}
              {a.last_error && <span className="gmail-tag warn" title={a.last_error}>Erreur de lecture</span>}
              {a.last_sync_at && <span className="gmail-tag">Lu le {new Date(a.last_sync_at).toLocaleString("fr-FR")}</span>}
            </div>
          </div>
          <label className="check-row gmail-inbox-toggle"><input type="checkbox" checked={a.inbox_enabled} onChange={(e) => act(() => api.patch(`/gmail/accounts/${a.id}`, { inbox_enabled: e.target.checked }))} data-testid={`gmail-inbox-${a.email}`} />Lire les réponses</label>
          <button type="button" className="secondary-button" onClick={() => remove(a)} data-testid={`gmail-remove-${a.email}`}><Trash2 size={15} /></button>
        </div>
      ))}
      <div className="button-row">
        <button className="secondary-button" type="button" onClick={onConnect} disabled={!configured} data-testid="connect-gmail-button"><LinkIcon size={17} />Ajouter un compte Gmail</button>
      </div>
      <p className="source-note">Pour reconnecter un compte (ex. nouvelle autorisation), ajoutez-le à nouveau avec la même adresse : il est mis à jour sans doublon. Chaque réponse reçue est rattachée à sa boîte, et la réponse part de cette même boîte.</p>
    </div>
  );
};
